import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-unregistered-box-track',
  templateUrl: './unregistered-box-track.component.html',
  styleUrls: ['./unregistered-box-track.component.scss'],
})
export class UnregisteredBoxTrackComponent implements OnInit {
  unregBoxForm: FormGroup;
  unregBoxResult: {
    trackingNumber: string;
    boxCode?: string | null;
    senderName?: string | null;
    senderAddress?: string | null;
    senderPhone?: string | null;
    consigneeName?: string | null;
    consigneeAddress?: string | null;
    consigneePhone?: string | null;
    cargoCompany?: string | null;
    noOfBoxes?: number | null;
    deliveredBoxes?: number | null;
    receivedAtWarehouse?: number | null;
    status: string;
    photoUrls: string[];
  } | null = null;

  errorMsg = '';
  showPodViewer = false;
  podIndex = 0;

  constructor(
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.unregBoxForm = this.fb.group({
      trackingNumber: [''],
    });
  }

  trackUnregisteredBox(): void {
    if (!this.unregBoxForm) return;

    this.errorMsg = '';
    this.unregBoxResult = null;
    let trackingNo: string =
      (this.unregBoxForm.get('trackingNumber')?.value || '').toString().trim();
    if (!trackingNo) {
      this.errorMsg = 'Please enter an unregistered box tracking number.';
      return;
    }

    this.spinner.show();
    this.dataService.trackUnregisteredBox(trackingNo).subscribe(
      (res) => {
        const trackingNumber =
          res?.trackingNumber || res?.trackingNo || trackingNo;
        const receivedAtWarehouse = res?.receivedAtWarehouse ?? null;
        let status = res?.status || res?.statusCode || '';
        if (!status) {
          if (receivedAtWarehouse != null && receivedAtWarehouse > 0) {
            status = 'Warehouse Sorting and Processing';
          } else {
            status = 'No Warehouse Receiving';
          }
        }

        let photoUrls: string[] = [];
        if (Array.isArray(res?.photoUrls)) {
          photoUrls = res.photoUrls
            .filter((x: any) => !!x)
            .map((x: any) => x.toString());
        } else if (Array.isArray(res?.podPhotos)) {
          photoUrls = res.podPhotos
            .map((p: any) => {
              if (p?.photoUrl) return p.photoUrl.toString();
              if (p?.photoBase64)
                return `data:image/jpeg;base64,${p.photoBase64}`;
              return null;
            })
            .filter((x: any) => !!x) as string[];
        }

        this.unregBoxResult = {
          trackingNumber,
          boxCode: res?.boxCode ?? null,
          senderName: res?.senderName ?? null,
          senderAddress: res?.senderAddress ?? null,
          senderPhone: res?.senderPhone ?? null,
          consigneeName: res?.consigneeName ?? null,
          consigneeAddress: res?.consigneeAddress ?? null,
          consigneePhone: res?.consigneePhone ?? null,
          cargoCompany: res?.cargoCompany ?? null,
          noOfBoxes: res?.noOfBoxes ?? null,
          deliveredBoxes: res?.deliveredBoxes ?? null,
          receivedAtWarehouse,
          status,
          photoUrls,
        };
        this.spinner.hide();
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
        this.unregBoxResult = null;
        this.errorMsg =
          'We are unable to find the unregistered box tracking number you provided. Please make sure you have the correct number.';
      }
    );
  }

  openPodViewer(startIndex: number = 0): void {
    if (!this.unregBoxResult?.photoUrls?.length) return;
    this.podIndex = Math.max(
      0,
      Math.min(startIndex, this.unregBoxResult.photoUrls.length - 1)
    );
    this.showPodViewer = true;
  }

  closePodViewer(): void {
    this.showPodViewer = false;
  }

  nextPod(): void {
    if (!this.unregBoxResult?.photoUrls?.length) return;
    this.podIndex =
      (this.podIndex + 1) % this.unregBoxResult.photoUrls.length;
  }

  prevPod(): void {
    if (!this.unregBoxResult?.photoUrls?.length) return;
    this.podIndex =
      (this.podIndex - 1 + this.unregBoxResult.photoUrls.length) %
      this.unregBoxResult.photoUrls.length;
  }
}

